<template>
    <ValidationObserver ref="gradeAppealForm">
        <b-container class="mt-5">
            <b-row>
                <b-col>
                    <b-card class="p-5">
                        <b-row>
                            <b-col cols="12" class="d-flex align-items-center justify-content-between mb-3">
                                <img src="../../../assets/img/BAU_Logo.png" height="75" alt="BAU Logo" />
                            </b-col>
                            <b-col>
                                <h4 class="title-font">{{ $t('grade_appeal_form').toUpperCase() }}</h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <p v-html="$t('grade_appeal_description')"></p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <h5 class="section-header">{{ $t('student_information').toUpperCase() }}</h5>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="name" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('student_name')">
                                        <b-form-input v-model="form.name">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="student_id" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('student_id')">
                                        <b-form-input v-model="form.student_id">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="3">
                                <ValidationProvider name="semester" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('semester')">
                                        <semesters-selectbox v-model="form.semester_id"
                                                             :validate-error="errors[0]"></semesters-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="3">
                                <ValidationProvider name="academic_year" rules="" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('academic_year')">
                                        <academic-years-selectbox
                                            v-model="form.academic_year"
                                            :validate-error="errors[0]"
                                        >

                                        </academic-years-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="3">
                                <ValidationProvider name="course_code" rules="required" v-slot="{errors}">
                                    <b-form-group :label="$t('course_code')">
                                        <course-auto-complete v-model="form.course_code"
                                                              resultType="code"
                                                              :validateError="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="3">
                                <ValidationProvider name="section" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('section')">
                                        <b-form-input type="number" min="1" v-model="form.section"
                                                      :class="errors[0] ? 'is-invalid' : ''"
                                                      :state="errors[0] ? false : null">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                                                 v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12">
                                <ValidationProvider name="course_instructor" rules="" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('course_instructor')">
                                        <staff-auto-complete v-model="form.course_instructor"
                                                             :validate-error="errors[0]"

                                        />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <h5 class="section-header">{{ $t('appeal_information').toUpperCase() }}</h5>
                            </b-col>

                            <b-col cols="12" md="6">
                                <ValidationProvider name="current_grade" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('current_grade')">
                                        <b-form-input v-model="form.current_grade" placeholder="Enter current grade"></b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col cols="12">
                                <b-form-group :label="$t('appeal_reasons')">
                                    <b-form-checkbox-group
                                        v-model="form.appeal_reasons"
                                        :options="appealReasonOptions"
                                        stacked
                                    ></b-form-checkbox-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12">
                                <ValidationProvider name="brief_explanation" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('provide_brief_explanation')">
                                        <b-form-textarea
                                            v-model="form.brief_explanation"
                                            rows="4"
                                            placeholder="Provide a brief explanation for your appeal"
                                        ></b-form-textarea>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="student_signature" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('student_signature')">
                                        <b-form-input v-model="form.student_signature"></b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="date" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date')">
                                        <select-date v-model="form.date" :validation-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <h5 class="section-header">{{ $t('course_instructor_decision').toUpperCase() }}</h5>
                            </b-col>
                            <b-col cols="12">
                                <ValidationProvider name="brief_rational" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('brief_rational')">
                                        <b-form-input v-model="form.brief_rational">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="course_instructor_signature" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('course_instructor_signature')">
                                        <b-form-input v-model="form.course_instructor_signature">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="signature_date" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date')">
                                        <select-date
                                            v-model="form.date"
                                            :validation-error="errors[0]"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </ValidationObserver>
</template>

<script>
import SelectDate from "@/components/interactive-fields/SelectDate.vue";
import SemestersSelectbox from '@/components/interactive-fields/SemestersSelectbox'
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
import CourseAutoComplete from "@/components/interactive-fields/CourseAutoComplete";

export default {
    components: {
        AcademicYearsSelectbox,
        SelectDate,
        SemestersSelectbox,
        CourseAutoComplete,
    },
    data() {
        return {
            form: {
                name: null,
                student_id: null,
                semester_id: null,
                year: null,
                course_code: null,
                section: null,
                course_instructor: null,
                signature_date: null,
                student_signature: null,
                date: null,
                academic_year: null,
                current_grade: null,
                appeal_reasons: [],
                brief_explanation: null,
                course_instructor_signature: null,
                brief_rational: null,
            },
            appealReasonOptions: [
                { text: 'Calculation errors or typographical errors', value: 'calculation_errors' },
                { text: 'Coursework submitted was excluded in grade calculation', value: 'excluded_coursework' },
                { text: 'Grading appears to be based on impermissible factors such as discrimination, bias, or retaliation', value: 'impermissible_factors' },
            ],
        };
    },
    metaInfo() {
        return {
            title: this.$t("grade_appeal_form"),
        };
    },
    methods: {},
};
</script>

<style scoped>
.title-font {
    font-weight: 700;
    color: #e6f0fa;
    background-color: #1a3c6d;
    padding: 10px 20px;
    border-radius: 5px;
    text-transform: uppercase;
    margin-bottom: 20px;
}
.section-header {
    font-weight: 600;
    color: #1a3c6d;
    padding: 8px 0;
    border-top: 3px solid #000000;
    border-bottom: 3px solid #000000;
    margin: 0 0 15px 0;
    width: 100%;
    display: block;
    text-align: left;
}
</style>
